import {api} from "@/shared/api";

import {Integrations} from "../integrations";
import {PersonioConfigDialog} from "./personioConfigDialog";
import {PanelBase} from "./panelBase";
import * as BootstrapModal from "@/shared/ui/bootstrapModal";
import * as Button from "@/shared/utils/button";
import {IntegrationType} from "@/shared/timrTypes";

export enum ExportWorkingTimeTypesMode {
	ALL_WORKING_TIME_TYPES = "ALL_WORKING_TIME_TYPES",
	ALL_ATTENDANCE_TIME_TYPES = "ALL_ATTENDANCE_TIME_TYPES",
	SELECTED_WORKING_TIME_TYPES = "SELECTED_WORKING_TIME_TYPES"
}

export interface PersonioConfig {
	clientId: string;
	clientSecret: string;
	syncWorkingTimes: boolean;
	workingTimeTypeMode: ExportWorkingTimeTypesMode;
	workingTimeTypeIds: string[];
	skipApproval: boolean;
	splitRecordingsAtMidnight: boolean;
	syncWorkingTimesDaysBack: number;
	copyDescription: boolean;
	copyTypeName: boolean;
	copyTypeShortname: boolean;
	dummyAttendances: boolean;
	dummyAttendancesDaysBack: number;
}

export class Personio extends PanelBase {
	private triggerSyncRequest: JQuery.jqXHR<void>;

	constructor() {
		super();
	}

	// Called when the element is inserted in the DOM
	// DEVNOTE: No shadow DOM here, so we can use external css
	private connectedCallback() {
		this.innerHTML = this.renderPanel({
			logoHtml: `<img src="/timr/images/integrations/personio.svg" alt="Personio" height="36px">`,
			topActionsHtml: this.renderEditActionButton(),
			footerHtml: `
				<div id="personioTriggerSyncContainer" class="display-flex flex-valign-middle" style="flex-wrap: wrap;">
					<button type="button" id="personioTriggerSync" class="btn btn-primary mt-10 mb-0 mr-10">
						<i class="far fa-file-export position-left" aria-hidden="true"></i>${messages["integrations.personio.sync"]}
					</button>
					<span id="personioTriggerSyncSuccess" class="text-success-800 ml-10 mt-10 mb-0 flex-vertical-center" style="display: none">
						<i class="fa fa-check mr-5"></i>${messages["integrations.personio.sync.success"]}
					</span>
					<span id="personioTriggerSyncFailure" class="text-danger-800 ml-10 mt-10 mb-0 flex-vertical-center" style="display: none">
						<i class="fa fa-times mr-5"></i>${messages["integrations.personio.sync.failure"]}
					</span>
				</div>
			`
		});
		this.initListeners();
		this.updateBanner();
	}

	private initListeners() {
		$(this).find("#edit").on("click", () => {
			PersonioConfigDialog.edit(this._integration, this._integration.configuration as PersonioConfig);
		});
		this.querySelector("[data-delete-integration]").addEventListener("click", () => {
			BootstrapModal.confirm({
				title: messages["dialog.delete.confirm"],
				message: messages["integrations.personio.delete.message"],
				yesAction: (confirmModal) => {
					confirmModal.close();
					Integrations.triggerDeletedIntegrationEvent(IntegrationType.PERSONIO, this.integration.id);
				}
			});
		});

		$(this).find("#personioTriggerSync").on("click", (e) => {
			Button.setLoading($(e.target));

			this.triggerSyncRequest?.abort();

			this.triggerSyncRequest = api("integrations/personio/triggerSync.json")
				.post({
					id: this._integration.id
				})
				.done(() => {
					$(this).find("#personioTriggerSyncSuccess").fadeIn(600);
					$(this).find("#personioTriggerSyncFailure").hide();
				})
				.fail(() => {
					$(this).find("#personioTriggerSyncSuccess").hide();
					$(this).find("#personioTriggerSyncFailure").fadeIn(600);
				})
				.always(() => Button.resetLoading($(e.target)));

		});
	}

	protected updateBanner(): void {
		const config = this._integration.configuration as PersonioConfig;
		$(this).find("#personioTriggerSyncContainer").toggle(config.syncWorkingTimes);
	}
}
